import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { AlertService } from '../services/alert.service';
import { Router } from '@angular/router';
import { ErrorSource, messageSource } from '../services/error-handling.service';



export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const alertService = inject(AlertService);
  const router = inject(Router);
  return next(req).pipe(
    catchError((res) => {

      if (res && res.error) {
        let msg = res.error

        const mSource = messageSource.find((x) => x.dbText === msg) as ErrorSource;

      
        if (mSource) {
          delete mSource.dbText;


    
          if (router.url && messageSource.find(v => router.url.includes(v.link))) {

            const params = messageSource.find(x => router.url.includes(x.link));
            const urlTree = router.parseUrl(router.url);
            const clientOrderId = urlTree.queryParams['clientorderid'];
            router.navigate(['authentication/error'], {
              queryParams: { errorType: JSON.stringify(params), clientorderid: clientOrderId }
            });
          }

          else {
            // const guid = req.params.get('guid');
            router.navigate(['authentication/error'],
              { queryParams: { errorType: JSON.stringify(mSource)} })
          }
        }
        else { alertService.notification({ message: msg, messageType: 'error', }) }

        return throwError(() => new Error(msg));
      } else return throwError(res);
    })
  );
};
